<template>
  <FullPageLayout class="game-container">
    <template v-if="fetchState.pending">
      <!-- loading -->
      <div></div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <GameHeader v-if="!IS_ONEDIO" />
      <GamesHeaderNew v-if="IS_ONEDIO" />
      <OBreadcrumb v-if="isMobile" class="capitalize text-md leading-18 my-4 ml-4" :items="breadcrumbRoutes" show-home-page-title />
      <AdController unit="masthead" class="sm:mt-9" />
      <Favorites />
      <GameCardList />
      <AdController unit="OyunlarInpageMobile3" />
      <GameBar v-if="IS_ONEDIO" />
      <SuggestedGames v-if="IS_ONEDIO" />
      <AdController unit="oyunlarFooter" />
    </template>
  </FullPageLayout>
</template>

<script>
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import { defineComponent, useFetch, useRoute, useContext } from '@nuxtjs/composition-api';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import { initializeAdLoaders } from '@/modules/ads/adUtils';
import AdController from '@/modules/ads/components/AdController';
import { OBreadcrumb } from '@/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import GameHeader from '~/modules/oyun/components/GameHeader.vue';
import GameCardList from '~/modules/oyun/components/GameCardList.vue';
import GameCard from '~/modules/oyun/components/GameCard.vue';
import GameBar from '~/modules/oyun/components/GameBar.vue';
import Favorites from '~/modules/oyun/components/Favorites.vue';
import SuggestedGames from '~/modules/oyun/components/SuggestedGames.vue';
import { useGameMeta } from '~/modules/oyun/utils/gameMeta';
import { IS_ONEDIO } from '~/constants/config';
import GamesHeaderNew from '~/modules/oyun/components/previousGames/GamesHeaderNew.vue';

export default defineComponent({
  components: {
    FullPageLayout,
    ErrorPageLayout,
    GameHeader,
    GameCardList,
    GameCard,
    GameBar,
    Favorites,
    SuggestedGames,
    AdController,
    OBreadcrumb,
    GamesHeaderNew,
  },
  head: {
    bodyAttrs: {
      class: 'bg-[#f7f8fb] o-ps-global',
    },
  },

  setup() {
    const fetchState = {};
    const route = useRoute();
    const { isMobile } = useDevice();
    const { i18n } = useContext();

    useGameMeta();
    const { generateAdConfig } = initializeAdLoaders();
    const serversideAdConfig = generateAdConfig('Games');
    useFetch(() => {
      serversideAdConfig();
    });
    const breadcrumbRoutes = [{ href: route.value.fullPath, name: `${i18n.t('game.games')}` }];
    return { isMobile, fetchState, IS_ONEDIO, breadcrumbRoutes };
  },
});
</script>
